/* eslint-disable @wyz/module/no-relative-import */
/* eslint-disable @wyz/i18n/no-plain-text */

import { Button, Card, Flex, Icon } from '@wyz/ui';
import { useNavigate } from 'react-router';
import { Trans } from '~/common/context';
import { SUPPORT_EMAIL } from '~/common/helpers';
import ErrorActions from './actions';

const Error500 = ({
  resetErrorBoundary,
}: {
  resetErrorBoundary?: () => void;
}) => {
  const navigate = useNavigate();
  return (
    <Card className='text-center h-100'>
      <Card.Body className='p-5'>
        <div className='display-1 text-300 fs-error'>500</div>
        <p className='lead mt-4 text-800 font-sans-serif fw-semi-bold'>
          <Trans i18nKey='app.errors.500.title' />
        </p>
        <hr />
        <p>
          <Trans i18nKey='app.errors.500.message' />
          <a href={`mailto:${SUPPORT_EMAIL}`} className='ms-1'>
            contact us
          </a>
          .
        </p>{' '}
        <Flex alignItems='center' justifyContent='center'>
          <Button
            id='home'
            variant='primary'
            type='button'
            size='sm'
            onClick={() => {
              if (resetErrorBoundary) {
                resetErrorBoundary();
              }
              void navigate('/');
            }}
          >
            <Icon icon={'home'} size='xs' className='me-2' />
            <Trans i18nKey='app.common.sidebar.dashboard' />
          </Button>
        </Flex>
        <ErrorActions resetErrorBoundary={resetErrorBoundary} />
      </Card.Body>
    </Card>
  );
};

export default Error500;
